<template>
  <div>
    <div class="addbumBtn" @click="dialogVisible = true">
      <i class="el-icon-plus"></i>
    </div>
    <el-dialog
      title="添加资源"
      :visible.sync="dialogVisible"
      :center="true"
      class="dialog"
      width="1000px"
    >
      <div>
        <el-form :inline="true" :model="formFuzzy" label-width="80px">
          <el-form-item label="资源名称:">
            <el-input
              v-model="formFuzzy.name"
              placeholder="输入商品名称"
              style="width: 180px"
            ></el-input>
          </el-form-item>
          <el-form-item label="专辑类型:">
            <el-select
                  v-model="formFuzzy.layerType"
                  clearable
                  style="width: 220px"
                >
                  <el-option
                    v-for="item in layerTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              style="background-color: #009e7d"
              @click="onQuery"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>
        
        <p style="color: red; font-weight: bold;margin-left: 80px;" v-if="label == '音频资源'">*听力熊T3，T4系列不支持多层专辑显示</p>
        <br v-else>
        <el-table
          ref="multipleTable"
          :data="queryData"
          stripe
          border
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          :header-cell-style="rowClass"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column
            prop="id"
            label="资源id"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="name"
            label="资源名称"
            align="center"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="lable"
            label="类型"
            align="center"
            min-width="100"
          >
            {{ label }}</el-table-column
          >
          <el-table-column
          prop="layerType"
          label="专辑类型"
          align="center"
          min-width="100"
          v-if="label == '音频资源'"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.layerType == 2">多层专辑</span>
            <span v-if="scope.row.layerType == 1">单层专辑</span>
          </template></el-table-column
        >
          <el-table-column
            v-if="label == '音频资源'"
            prop="res_count"
            label="数量"
            align="center"
            min-width="100"
          ></el-table-column>
          <el-table-column
            v-else
            prop="count"
            label="数量"
            align="center"
            min-width="100"
          ></el-table-column>

          <el-table-column
            prop="enabled"
            label="状态"
            align="center"
            min-width="100"
            v-if="typeValue == 1 || typeValue == 2"
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.enabled" type="success">已上架</el-tag>
              <el-tag v-else type="danger">已下架</el-tag>
            </template></el-table-column
          >
          <el-table-column
            prop="enabled"
            label="状态"
            align="center"
            min-width="100"
            v-if="typeValue == 3"
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status == 1" type="success"
                >已上架</el-tag
              >
              <el-tag v-if="scope.row.status == 0" type="danger">已下架</el-tag>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="queryParams.page"
            :page-sizes="[20, 50, 100]"
            :page-size="queryParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal"
          ></el-pagination>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center;"> 
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click="dialogConfirm"
          style="background-color: #009e7d"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ApiMessage } from "@/utils/util";
export default {
  name: "addClassResource",
  data() {
    return {
      label: "", //类型
      dialogVisible: false,
      formFuzzy: {
        name: "",
        layerType:""
      },
      layerTypeList:[{label:"单层专辑",value:1},{label:"多层专辑",value:2}],
      queryData: [],
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      pageTotal: 0,
      multipleSelection: [],
      sectionList: [],
      ownCpList: [], //音频专辑
      haoxueduo: {}, //获取专辑内容提供商
    };
  },
  props: ["typeValue"],
  watch: {
    typeValue(newVal) {
      console.log(
        newVal,
        "addClassResourceaddClassResourceaddClassResourceaddClassResource"
      );
      if (newVal == new Number(1)) {
        this.fetchPackageList();
        // this.fetchPackageList1();
      } else if (newVal == new Number(2)) {
        this.fetchExtraList();
        // this.fetchExtraList1();
      } else if (newVal == new Number(3)) {
        this.initCplists().then((res) => this.fetchAudioCd(res));
        // this.initCplists().then((res) => this.fetchAudioCd1(res));
      } else {
        this.queryData = [];
        this.queryParams = {
          page: 1,
          pageSize: 20,
        };
        this.pageTotal = 0;
      }
    },
  },
  methods: {
    rowClass() {
      return "background:#f9f9f9;color:#000000;font-size:14px;height:22px";
    },
    onQuery() {
      this.queryParams.page = 1;
      if (this.typeValue == new Number(1)) {
        this.fetchPackageList();
      } else if (this.typeValue == new Number(2)) {
        this.fetchExtraList();
      } else if (this.typeValue == new Number(3)) {
        this.initCplists().then((res) => this.fetchAudioCd(res));
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      if (this.typeValue == new Number(1)) {
        this.fetchPackageList();
      } else if (this.typeValue == new Number(2)) {
        this.fetchExtraList();
      } else if (this.typeValue == new Number(3)) {
        this.initCplists().then((res) => this.fetchAudioCd(res));
      }
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      if (this.typeValue == new Number(1)) {
        this.fetchPackageList();
      } else if (this.typeValue == new Number(2)) {
        this.fetchExtraList();
      } else if (this.typeValue == new Number(3)) {
        this.initCplists().then((res) => this.fetchAudioCd(res));
      }
    },
    dialogConfirm() {
      this.$emit("changeResource", this.multipleSelection);
      this.dialogVisible = false;
      console.log(
        this.multipleSelection,
        "this.multipleSelectionthis.multipleSelectionthis.multipleSelectionthis.multipleSelection"
      );
      this.$refs.multipleTable.clearSelection();
    },
    // 音频专辑
    fetchAudioCd(haoxueduo) {
      this.label = "音频资源";
      let cpid = [];
      cpid.push(haoxueduo.id);
      let params = {
        appId: this.$API.APPID,
        dbId: cpid,
        pid: 0,
        needLayerType:1,
      };
      if (this.formFuzzy.name != "") {
        params.name = this.formFuzzy.name;
      }
      if (this.formFuzzy.layerType != "") {
        params.layerType = this.formFuzzy.layerType;
      }
      params.pageSize = this.queryParams.pageSize;
      params.page = this.queryParams.page;
      this.$axios
        .post("/aries-api/album/list", params)
        .then((response) => {
          if (response.data.result == 0) {
            console.log(response.data);
            this.queryData = response.data.data.list;
            this.pageTotal = response.data.data.pager.total;
            // this.$emit("changeResourceList", this.queryData);
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },

    fetchAudioCd1(haoxueduo) {
      this.label = "音频资源";
      let cpid = [];
      cpid.push(haoxueduo.id);
      let params = {
        appId: this.$API.APPID,
        dbId: cpid,
      };
      if (this.formFuzzy.name != "") {
        params.name = this.formFuzzy.name;
      }
      params.pageSize = 20000000;
      this.$axios
        .post("/aries-api/album/list", params)
        .then((response) => {
          if (response.data.result == 0) {
            console.log(response.data.data.list);
            // this.$emit("changeResourceList", response.data.data.list);
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },

    initCplists() {
      return new Promise((reslove, reject) => {
        let params = {
          appId: this.$API.APPID,
          //otype: 2,
          dtype: 0,
          onlyAuthorised: 1,
          needAppName: 1,
        };
        this.$axios
          .post("/aries-api/resourceDb/list", params)
          .then((response) => {
            console.log(response, "response===");
            if (response.data.result == "0") {
              if (
                response.data.data.length != 0 &&
                response.data.data.own &&
                response.data.data.own.length != 0
              ) {
                this.ownCpList = JSON.parse(
                  JSON.stringify(response.data.data.own)
                );
                this.haoxueduo = this.ownCpList.find((item) => {
                  return item.name === "好学多音频资源";
                });
                console.log(
                  this.haoxueduo,
                  Object.keys(this.haoxueduo).length,
                  "this.haoxueduo-----好学多音频资源"
                );

                if (
                  this.haoxueduo == undefined ||
                  Object.keys(this.haoxueduo).length == 0
                ) {
                  alert("请核实音频资源专辑是否创建");
                  return;
                }
              } else {
                alert("请核实音频资源专辑是否创建");
                return;
              }
            }
            reslove(this.haoxueduo);
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    // 体系课
    fetchPackageList() {
      this.label = "体系课";
      console.log(
        "fetchPackageListfetchPackageListfetchPackageListfetchPackageList "
      );
      let params = {
        appId: this.$API.APPID,
        pageSize: this.queryParams.pageSize,
        page: this.queryParams.page,
        packageType: 1,
        isIncludeAuthInfo: true,
      };
      if (this.formFuzzy.name != "") {
        params.name = this.formFuzzy.name;
      }
      this.eduAxiosPostRequest(
        "/edu/eduAdmin/course/package_list",
        params
      ).then((res) => {
        if (res != null) {
          let m = JSON.parse(res);
          this.queryData = m.list;
          this.pageTotal = m.pager.total;
        }
      });
    },

    fetchPackageList1() {
      this.label = "体系课";
      console.log(
        "fetchPackageListfetchPackageListfetchPackageListfetchPackageList "
      );
      let params = {
        appId: this.$API.APPID,
        packageType: 1,
        pageSize: 20000000,
        isIncludeAuthInfo: true,
      };
      if (this.formFuzzy.name != "") {
        params.name = this.formFuzzy.name;
      }
      this.eduAxiosPostRequest(
        "/edu/eduAdmin/course/package_list",
        params
      ).then((res) => {
        if (res != null) {
          let m = JSON.parse(res);
          // this.$emit("changeResourceList", m.list);
        }
      });
    },

    // 特色课程
    fetchExtraList() {
      this.label = "特色课程";
      console.log("fetchExtraListfetchExtraListfetchExtraListfetchExtraList");
      let params = {
        appId: this.$API.APPID,
        courseType: 1,
        isIncludeAuthInfo: true,
        pageSize: this.queryParams.pageSize,
        page: this.queryParams.page,
      };
      if (this.formFuzzy.name != "") {
        params.name = this.formFuzzy.name;
      }
      this.eduAxiosPostRequest("/edu/eduAdmin/course/extra_list", params).then(
        (res) => {
          if (res != null) {
            let m = JSON.parse(res);
            this.queryData = m.list;
            this.pageTotal = m.pager.total;
          }
        }
      );
    },
    fetchExtraList1() {
      this.label = "特色课程";
      console.log("fetchExtraListfetchExtraListfetchExtraListfetchExtraList");
      let params = {
        appId: this.$API.APPID,
        pageSize: 20000000,
        courseType: 1,
        isIncludeAuthInfo: true,
      };
      if (this.formFuzzy.name != "") {
        params.name = this.formFuzzy.name;
      }
      this.eduAxiosPostRequest("/edu/eduAdmin/course/extra_list", params).then(
        (res) => {
          if (res != null) {
            let m = JSON.parse(res);
            // this.$emit("changeResourceList", m.list);
          }
        }
      );
    },
    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            console.log(response);
            if (response.data.rc == "0") {
              if (
                address.indexOf("package_del") != -1 ||
                address.indexOf("package_batch") != -1
              ) {
                resolve(JSON.stringify(response.data.msg));
              } else {
                resolve(JSON.stringify(response.data.data));
              }
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>

<style scoped>
.addbumBtn {
  width: 120px;
  height: 35px;
  border-radius: 4px;
  background: #009e7d;
  color: #fff;
  text-align: center;
  cursor: pointer;
}
.dialog >>> .el-dialog__footer {
  text-align: right;
}

.dialog >>> .el-pager li.active {
  background-color: #009e7d;
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// addClassResource.vue?6c9af7d1